import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { Controller } from '../../common/Controller';
import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Breadcrumbs } from '../../components/Breadcrumbs'
import { BreadcrumbsHelper } from '../../helpers/BreadcrumbsHelper';
import { SelectComponentV2 } from '../../components/SelectComponentV2';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Popover from '@material-ui/core/Popover';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import Menu from '@material-ui/core/Menu';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import momentTz from 'moment-timezone';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { AppTheme } from '../../styles/AppTheme';
import { SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS } from 'constants';
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers';
import { TextInputComponent } from '../../components/TextInputComponent';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import { AppConfig } from '../../AppConfig';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SearchTextField } from './SearchTextField';
import Tooltip from '@material-ui/core/Tooltip';
import { adminData } from '../../data/AdminData';

export class EventList extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  getInfoString = (item) => {
    const minutes = moment().diff(moment(item.event_time), 'minutes')
    if (minutes > 60) {
      const hours = moment().diff(moment(item.event_time), 'hours')
      if (hours > 24) {
        const days = moment().diff(moment(item.event_time), 'days')
        return days + ' days ago'
      } else {
        return hours + ' hrs ago'
      }
    } else if (minutes > 0) {
      return minutes + ' minutes ago'
    }
  }

  eventList = (data) => {
    return (
      <div className={css(Styles.innerEventListContent)}>
        {data &&
          data.map((item, index) => {
            return (
              <div
                className={this.props.eventsByGroupId[item.groupId] && this.props.eventsByGroupId[item.groupId].length > 0 ?
                  css(Styles.eventListStackContent) : css(Styles.eventListContent)}
                onClick={() => this.props.onEventTileSelect(item, index)}>
                {item.image ?
                  <div className={css(Styles.eventListImageConatiner)} >
                    <img
                      key={item.image}
                      src={item.image}
                      onError={(e) => {
                        e.target.src = require('../../assets/images/error2.svg')
                      }}
                      className={css(Styles.eventImg)} />
                  </div>
                  :
                  <div className={css(Styles.eventImageLoading)}>
                    <p className={css(Styles.eventListTitle)}>Image loading...</p>
                  </div>
                }
                <div className={css(Styles.eventListTitleConatiner)}>
                  {item.name &&
                    <p className={css(Styles.eventListTitle)}>{item.name}</p>
                  }
                  <div className={css(Styles.eventListDateContainer)}>
                    <p className={css(Styles.eventListDate)}>
                      {this.getInfoString(item)}</p>
                    {adminData.priorityValues.map((value) => {
                      return (
                        value.value === item.priority &&
                        <div className={css(Styles.editAlertDotContent)}
                          style={{ backgroundColor: value.color }} />
                      )
                    })}
                  </div>
                </div>
              </div>
            )
          })}
      </div>
    )
  }

  getEventCount = () => {
    //console.log('pageNumber', this.props.pageNumber)
    return 'Page ' + (this.props.pageNumber + 1)
  }

  getPaginationData = () => {
    return (
      <div className={css(Styles.paginationContainer)}>
        <Tooltip title='Previous'>
          <IconButton disabled={this.props.pageNumber === 0} className={css(Styles.refreshIconContainer)}>
            <Icon className={css(Styles.refreshIcon)} color='primary' onClick={() => this.props.updateEvents('prev')}>
              navigate_before
            </Icon>
          </IconButton>
        </Tooltip>
        <p className={css(Styles.pageNumber)}>{this.getEventCount()}</p>
        <Tooltip title='Next'>
          <IconButton disabled={!this.props.paginate} className={css(Styles.refreshIconContainer)}>
            <Icon className={css(Styles.refreshIcon)} color='primary' onClick={() => this.props.updateEvents('next')}>
              navigate_next
            </Icon>
          </IconButton>
        </Tooltip>
      </div>
    )
  }

  render = () => {
    return (
      <div className={(this.props.relativeImageSliderMode) ?
        css(Styles.innerEventListContainerRelativeOpen) : css(Styles.innerEventListContainer)} >

        <div className={css(Styles.innerSearchContainer)}>
          <SearchTextField
            searchHandler={this.props.searchHandler}
          />
        </div>

        <div>
          {this.getPaginationData()}
          <p className={css(Styles.innerSearchContent)}>{this.props.eventList.length > 0 ?
            'Showing ' + this.props.eventList.length + ' results' : ' No match found'}</p>
        </div>

        {this.props.eventListLoading ?
          <CircularProgress
            color='primary'
            size={40}
            className={css(Styles.progress)} />
          :
          this.eventList(this.props.eventList)
        }

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/screens/ClientPlace/EventList.js